import React from "react";
import styled, { keyframes } from "styled-components";
import { NavLink } from "react-router-dom";

import LogoSvg from "./Logo";

const HueRotate = keyframes`
  from {
    filter: hue-rotate(0deg);
  }

  to {
    filter: hue-rotate(360deg);
  }
`;

const LogoText = styled.div`
  font-size: 36px;
  line-height: 0;
  font-weight: 500;
  font-family: Groningenfont, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  display: block;
  color: #fff;
`;
const LogoTextSmall = styled.div`
  margin-left: 4px;
  line-height: 9px;
  font-size: 8px;
  text-transform: uppercase;
  font-weight: 500;
  font-family: Groningenfont, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  display: block;
  color: #fff;
  margin-right: auto;
  margin-bottom: -4px;
  opacity: 0;
  transform: translateX(-10px);
  transition: 0.2s;
`;

const LogoContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  &:hover {
    text-decoration: none;
    ${LogoTextSmall} {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const VW = styled.a`
  height: 1em;
  .logo-svg {
    height: 1em;
    fill: hsl(240, 2%, 43%);
  }
  &:hover {
    text-decoration: none;
    animation: ${HueRotate} 20s linear infinite;
    animation-delay: 3s;
    .logo-svg {
      fill: #ffbc00;
    }
  }
`;

export default function Logo() {
  return (
    <LogoContainer>
      <LogoText>C3</LogoText>
      <LogoTextSmall>
        Complete
        <br />
        Cloud
        <br />
        Control
      </LogoTextSmall>
      <VW href="https://vette.website">
        <LogoSvg className="logo-svg" />
      </VW>
    </LogoContainer>
  );
}
